// Focus an opt-in field as soon as it is inserted — including inside Unpoly overlays, where the
// native [autofocus] attribute is not always honored. Add the `js-autofocus` class to opt in
// (e.g. the quantity field of the "Material hinzufügen" modal). Selecting the value lets the user
// overwrite the prefilled amount immediately.
//
// This focuses the field only once it actually exists (when the modal is rendered), not when the
// opening button is pressed. In the common flow the search keyboard is already open, so focusing
// the modal field simply transfers the keyboard to it.
up.compiler('.js-autofocus', (element) => {
  element.focus({ preventScroll: true });
  if (typeof element.select === 'function') {
    try { element.select(); } catch (error) { /* not a text-like field */ }
  }
});
